import { render, staticRenderFns } from "./search-consent-imports.vue?vue&type=template&id=0480a65b&scoped=true&"
import script from "./search-consent-imports.vue?vue&type=script&lang=js&"
export * from "./search-consent-imports.vue?vue&type=script&lang=js&"
import style0 from "./search-consent-imports.vue?vue&type=style&index=0&id=0480a65b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0480a65b",
  null
  
)

export default component.exports